import { render, staticRenderFns } from "./ChangeOrderForm.vue?vue&type=template&id=130db695"
import script from "./ChangeOrderForm.vue?vue&type=script&lang=js"
export * from "./ChangeOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports